




















































import Vue from 'vue'
import infoHeader from '@/components/Ui/ActiveInfoPage/Blocks/infoHeader.vue'
import itemName from '@/components/Ui/ActiveInfoPage/Blocks/itemName.vue'
import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'

export default Vue.extend({
  name: 'studentInfo',
  props: {
    scope: {},
    options: {}
  },
  components: {
    infoHeader,
    itemName,
    infoRowsBlock
  }
})
